
<section class="fixed-height parallaxBg bg-img" data-bg="assets/img/catalogacion/fondo-catalogacion.jpg" style="background-image: url('assets/img/catalogacion/fondo-catalogacion.jpg')">
  <div class="container h-100">
    <div class="row align-items-center h-100">
      <div class="col-lg-7 text-center m-auto">
        <div class="about-us-content white mt-100">
          <h3 style="color: white">
            Componente de Catalogación Proyecto IOARR
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="team-area-wrapper bg-offwhite pt-80 pt-md-80 pt-sm-60 pb-40 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-rosario-2.png'); background-size: cover;
    background-position: center;">
  <div class="container">
      <div class="row">
          <div class="col-lg-6 text-center">
              <div class="">
                  <h2>CATALOGACIÓN DE INMUEBLES</h2>
                  <p class="m-0" style="font-size: 16px; line-height: 1.9;">La catalogación de inmuebles es un servicio que brinda la Gerencia de Centro Histórico como parte del trámite
                  para la obtención de licencia de edificación, contiene información respecto al valor patrimonial del inmueble. Estas fichas fueron elaboradas durante los años
                  2009-2013 y a partir de ese año se fueron actualizando predios en los diferentes sectores que se subdividieron, construcciones nuevas, modificaciones y otros.
                  Mediante la Inversión IOARR “ADQUISICIÓN DE SISTEMA DE INFORMACIÓN EN LA OPTIMIZACIÓN DEL SISTEMA DE INFORMACIÓN DEL SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL
                  CENTRO HISTÓRICO DISTRITO DE CUSCO, PROVINCIA CUSCO, DEPARTAMENTO CUSCO”, se ha actualizado la información que fue elaborada en los años 2009-2014, 2018 y con
                  el presente proyecto se ha actualizado las categorías de catalogación y han disminuido los predios no catalogados.

                  </p>
              </div>
          </div>
          <div class="col-lg-6 text-center">
              <div class="speaker-member-wrap mt-sm-10" style="margin-top:-20px;">
                <figure class="speaker-thumbnail">
                    <img src="assets/img/catalogacion/erick.jpg"
                        alt="GERENCIA DEL CENTRO HISTÓRICO"
                        style="width: 300px; display: block; margin: 0 auto;">
                </figure>
                <div class="speaker-info">
                    <h3 style="text-align: center;">ARQ. FRANK ERICK HUACHACA MERINO</h3>
                    <h6 class="designation mb-20" style="text-align: center;">COORDINADOR COMPONENTE DE CATALOGACIÓN</h6>
                </div>
            </div>
          </div>
      </div>
  </div>
</section>
<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion03.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion03.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion10.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion10.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion05.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion05.jpg" alt="Portfolio">
                </a>
              </figure>

              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion04.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion04.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion08.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion08.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/catalogacion/catalogacion01.jpg" class="btn-img-gallery">
                      <img src="assets/img/catalogacion/catalogacion01.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion07.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion07.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion02.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion02.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion06.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion06.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion09.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion09.jpg" alt="Portfolio">
                </a>
              </figure>
          </div>
      </div>
  </article>
</div>
<section id="landing-service-area-wrapper" class="pt-68 pt-md-26 pt-sm-20 pb-114 pb-md-76 pb-sm-56" style="background-image: url('/assets/img/fondo-tomo11.png'); background-size: cover;
    background-position: center;">
  <div class="container">

    <div class="row">
      <div class="col-lg-12 text-center" style="margin-bottom:-60px;">
        <div class="section-title-wrap">
          <h3 style="color:white">Productos del Componente Catalogación</h3>
        </div>
      </div>
      <!-- Single Service Item #1 -->
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>CATALOGACION DE INMUEBLES: </h3>
            <p class="m-0">
            Se obtuvo como producto la catalogación de 50 inmuebles del centro histórico del cusco, priorizando la catalogación de predios declarados monumentos (PM-I),
            con valor patrimonial (PI-II), valor contextual (VC-III), algún elemento patrimonial (EP-IV) distribuidos en los sectores de gestión SG-0I Núcleo, SG-02
            San Cristóbal, SG-03 Santo Domingo, SG-04 San Blas, SG-05 Santa Ana, SG-06 San Pedro, SG-07 Pumacchupan y SG-08.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-12">
        <div class="single-service-wrap d-flex">
          <span class="service-icon"><i class="fa fa-angle-double-right"></i></span>
          <div class="service-info">
            <h3>CATALOGACION DE AMBIENTES URBANOS</h3>
            <p class="m-0">
            Se tuvo como producto final la catalogación de 5 ambientes urbanos, los que se ubican en los sectores de gestión SG-08 y SG-09 que se incluyen en el
            Área de Estructuración AE-I de acuerdo Plan Maestro del Centro Histórico del Cusco 2018-2028, los que se detallan a continuación:
            </p>
            <ul>
              <li><i class="fa fa-play"></i> •	Ambiente urbano plazoleta Belén.</li>
              <li><i class="fa fa-play"></i> •	Ambiente urbano plazoleta Santiago.</li>
              <li><i class="fa fa-play"></i> •	Ambiente urbano calle Almudena.</li>
              <li><i class="fa fa-play"></i> •	Ambiente urbano Huaca Mesa Redonda.</li>
              <li><i class="fa fa-play"></i> •	Ambiente urbano Huaca de Teteqaqa.</li>
            </ul>
          </div>
        </div>
      </div>

    </div>
  </div>
</section>
<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion11.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion11.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion12.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion12.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion13.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion13.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion14.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion14.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/catalogacion/catalogacion15.jpg" class="btn-img-gallery">
                      <img src="assets/img/catalogacion/catalogacion15.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion16.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion16.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion17.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion17.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion18.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion18.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion19.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion19.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion20.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion20.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion21.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion21.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion22.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion22.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion23.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion23.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion24.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion24.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion25.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion25.jpg" alt="Portfolio">
                </a>
              </figure>
          </div>
      </div>
  </article>
</div>

<section class="team-member-area bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-120 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-plan-maestro.png'); background-size: cover; background-position: center;">
  <div class="container">
    <div class="row">
      <!-- Start Section title -->
      <div class="col-lg-6 m-auto text-center">
        <div class="section-title-wrap">
          <h2>Equipo de trabajo</h2>
          <p class="mb-0">El componente de catalogación contó con el siguiente equipo de trabajo.</p>
        </div>
      </div><!-- End Section title -->
    </div>
    <div class="port-details-con-inner">
          <div class="single-post-details__footer m-0">
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Catalogador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Arq. ARES ALANYA PANTOJA </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Catalogador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Arq. JUAN PERCY CCLOQUE LAURA </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Catalogador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Arq. YURICO LILI RIVERA CHALLCO </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Catalogador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Arq. CRISTIAN MAX ARIAS CAHUANA </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Arquéologo:</h5>
              </div>
              <div class="footer-item-right">
                <span>Arqueol. EMETERIO APAZA QUISPE </span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Catalogador:</h5>
              </div>
              <div class="footer-item-right">
                <span>Br. Arqueol. CYNTHIA VANESSA HANCCO LUNA</span>
              </div>
            </div>
            <div class="single-post-details__footer__item">
              <div class="footer-item-left">
                <h5 class="item-head"><i class="fa fa-tags"></i> Topógrafo:</h5>
              </div>
              <div class="footer-item-right">
                <span>Topógrafo MARIO FIDEL FERRO LIMA</span>
              </div>
            </div>

          </div>
        </div>
  </div>
</section>

<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion26.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion26.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion27.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion27.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion28.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion28.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion29.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion29.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/catalogacion/catalogacion30.jpg" class="btn-img-gallery">
                      <img src="assets/img/catalogacion/catalogacion30.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion31.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion31.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion32.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion32.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion33.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion33.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion34.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion34.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion35.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion35.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/catalogacion/catalogacion36.jpg" class="btn-img-gallery">
                    <img src="assets/img/catalogacion/catalogacion36.jpg" alt="Portfolio">
                </a>
              </figure>

          </div>
      </div>
  </article>
</div>
